var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 28.5,
    fill: "white",
    stroke: "#21A6E9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 20.0625H42V31.875H25.125V20.0625Z",
    fill: "#21A6E9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3125 38.625C40.3125 40.4897 38.8022 42 36.9375 42C35.0728 42 33.5625 40.4897 33.5625 38.625C33.5625 36.7603 35.0728 35.25 36.9375 35.25C38.8022 35.25 40.3125 36.7603 40.3125 38.625Z",
    fill: "#21A6E9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9375 33.5625C39.1312 33.5625 40.9875 34.9125 41.6625 36.9375H42V33.5625H36.9375Z",
    fill: "#21A6E9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4375 23.4375H16.6875L15 30.1875V36.9375H17.025C17.7 34.9125 19.5563 33.5625 21.75 33.5625C23.9437 33.5625 25.8 34.9125 26.475 36.9375H32.2125C32.8875 34.9125 34.7438 33.5625 36.9375 33.5625H23.4375V23.4375ZM21.75 30.1875H16.6875L18.0375 25.125H21.75V30.1875Z",
    fill: "#21A6E9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.125 38.625C25.125 40.4897 23.6147 42 21.75 42C19.8853 42 18.375 40.4897 18.375 38.625C18.375 36.7603 19.8853 35.25 21.75 35.25C23.6147 35.25 25.125 36.7603 25.125 38.625Z",
    fill: "#21A6E9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon2.d03a2dffceea2f91b99f495c1f9f5648.svg";
export { ForwardRef as ReactComponent };